import { useEffect, useState } from 'react'

// local imports
import FavoritesService from 'service/FavoritesService'
import { IFavoriteLocations } from 'types/FavoritesType'

export default function useGetFavoriteLocations(isShared: boolean) {
  const [list, setList] = useState<IFavoriteLocations[] | []>([])
  const [loading, setLoading] = useState(false)

  const getList = (showLoading = false) => {
    if (showLoading) setLoading(true)
    FavoritesService.getFavoriteLocations(isShared)
      .then((r) => setList(r.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getList(true), [])

  return { list, setList, loading }
}
